// @flow
import {
  //redux as coreRedux,
  createReducer,
  createOfflineReducer,
  selectors as S,
} from "@swarm2/core"
import {reduceKeys as units} from "../units"
const isOffline = S.flags.offline()

const ui = (state = {}, action) => state
//const ui = combineReducers(_.mapValues({
//  //updates,
//}, m => m.reduceUI))

// Legacy reducers.
//export const reduceByKey = combineReducers({
//  ...coreRedux.reducers,
//  ...(isOffline ? coreRedux.offlineReducers : {}),
//  form: units.form, // TODO: this belongs under ui
//  ui,
//})
//
//export function reducer(state = {}, action) {
//  state = reduceByKey(state, action)
//  return state
//}

// New-style reducers.
export const reducer = (isOffline ? createOfflineReducer : createReducer)({
  form: units.form, // TODO: this belongs under ui
  ui,
})



// WEBPACK FOOTER //
// ./src/redux/Reducers.js